<template>
  <n-tooltip trigger="hover">
    <template #trigger>
      <n-button quaternary @click="globalStore.setTheme()" class="mr-1">
        <template #icon>
          <n-icon>
            <component :is="component"/>
          </n-icon>
        </template>
      </n-button>
    </template>
    {{ tooltip }}
  </n-tooltip>
</template>

<script setup lang="ts">
import {computed,ref} from "vue";
import {Contrast, LightFilled, AsleepFilled} from "@vicons/carbon";
import {useGlobalConfigStore} from "@/stores/global";

const globalStore = useGlobalConfigStore();
const tooltip = ref("使用系统主题");

const component = computed(() => {
  switch (globalStore.theme) {
    case "osTheme":
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      tooltip.value = "使用系统主题";
      return Contrast;
    case "lightTheme":
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      tooltip.value = "亮色";
      return LightFilled;
    case "darkTheme":
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      tooltip.value = "暗色";
      return AsleepFilled;
  }

  return Contrast;
})
</script>

<style scoped lang="less">

</style>